import React from "react";
import DecorpotLogo from "../assets/img/org/deco_new_logo.png";

// Subtle full-page Decorpot logo watermark, used behind the customer-facing
// bank-details collection forms (referral, refund, site visit) for branding.
const BrandedFormBackground = ({ children }) => (
    <div style={{ minHeight: "100vh", width: "100%", backgroundColor: "#f4f6f8", position: "relative", overflow: "hidden" }}>
        <img
            src={DecorpotLogo}
            alt=""
            aria-hidden="true"
            style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "min(70vw, 520px)",
                opacity: 0.06,
                pointerEvents: "none",
                userSelect: "none",
            }}
        />
        <div style={{ position: "relative", zIndex: 1 }}>
            {children}
        </div>
    </div>
);

export default BrandedFormBackground;
